<app-card>
  <span class="header d-flex justify-content-between">
    <span>{{ label }}</span>
    <app-toggle [(enabled)]="enabled" [allowChanges]="allowChanges" (toggle)="handleToggle($event)"></app-toggle>
  </span>
  <div class="col-12">
    <div class="form-group">
      <label>Alert Message</label>
      <textarea
        class="form-control"
        placeholder="Enter alert code message here"
        rows="4"
        [disabled]="!allowChanges"
        [(ngModel)]="message"
        (change)="handleChangeMessage($event)"></textarea>
    </div>
  </div>
</app-card>
